export default {"src":"/_next/static/media/question-mark-own.16dbff6c.svg","height":100,"width":100};